import React from 'react';

function Blocka({ language }) {
  // Content for both English and Hindi
  const content = {
    en: [
      {
        title: "Yagyaseni—Born from the Sacrificial Fire",
        image: "images/main-attractions/block-b/block-b-2.png",
        description: `In this installation, the pivotal moment of Draupadi's birth emerging from the fire, is brought to life through a hyper-realistic sculpture. Her emergence from the fire symbolizes her purity and divine origin.`,
        label: "Main Attraction",
      },
      {
        title: "Warriors of Destiny",
        image: "images/main-attractions/block-b/block-b-3.png",
        description: `This section depicts Dronacharya, Guru of the Kuru princes and King Drupad of Panchal. From King Drupad’s penance were born Dhrishtadyumn and Draupadi. Alongside is the portrayal of Shikhandi, whose presence played a decisive role in Bhishm’s downfall in battle.`,
      },
      {
        title: "Lakshagrah-Palace of Fire",
        image: "images/main-attractions/block-b/block-b-6.png",
        description: `At Lakshagrah, Duryodhan and Shakuni plotted to kill the Pandavs and their mother in a flammable “House of Lac.” With Vidur’s help, the Pandavs escaped through a tunnel, foiling the plan. This failed attempt foreshadows the imminent conflict and the epic Kurukshetr war.`,
      },
      {
        title: "The Story of Khandavprasth",
        image: "images/main-attractions/block-b/block-b-4.png",
        description: `In Khandavprasth, Lord Agni, disguised as a Brahman, seeks Arjun and Krishna’s help to burn the Khandav forest, home to the Nagas, sparing only Ashwasen. Two sculptures depict Arjun targeting the forest and Parikshit meditating before Takshak’s fatal bite.`,
      },
      {
        title: "Draupadi's Swayamwar",
        image: "images/main-attractions/block-b/block-b-5.png",
        description: `This exhibit presents Draupadi's Swayamvar through a hyper-realistic sculpture of Arjun aiming at a revolving fish's eye. King Drupad’s challenge tested the suitors’ skill using only the fish’s reflection. Arjun’s precise shot secured his victory, resulting in Draupadi marrying him as per the Swayamvar’s conditions.`,
        label: "Main Attraction",
      },
      {
        title: "Chausar - The Dice of Deceit",
        image: "images/main-attractions/block-b/block-b-7.png",
        description: `This exhibit recreates Hastinapur’s court on the day of the fateful dice game, where every move affects the kingdom’s future. A colossal dice hangs above, symbolizing the game’s gravity and unpredictability. The moment embodies the timeless struggle between honour, ambition, righteousness, and deceit, leaving a lasting impression on all who witness it.`,
      },
      {
        title: "Draupadi and Bheeshm - The Dharma Dialogue",
        image: "images/main-attractions/block-b/block-b-8.png",
        description: `After the dice game, Draupadi’s dialogue symbolizes profound defiance in the Mahabharat. Her words challenge the unjust social order that allowed her to be gambled away. By questioning the game’s legitimacy and confronting the Kuru elders, she embodies resistance against oppression, asserting moral authority, justice, and unwavering dignity.`,
        label: "Main Attraction",
      },
      // Add other items here...
    ],
    hi: [
      {
        title: "याज्ञसेनी—अग्निसुता द्रौपदी",
        image: "images/main-attractions/block-b/block-b-1.png",
        description: `यहाँ इस स्थापना में, द्रौपदी के जन्म के महत्वपूर्ण क्षण को, आग से उभरते हुए, एक अति-यथार्थवादी माध्यम से जीवंत किया गया है। द्रौपदी का आग से उभरना उनकी शुद्धता और दिव्य उत्पत्ति का प्रतीक है।`,
        label: "मुख्य आकर्षण",
      },
      {
        title: "नियति के योद्धा",
        image: "images/main-attractions/block-b/block-b-2.png",
        description: `इस प्रसंग में कुरु राजकुमारों के गुरु द्रोणाचार्य और पंचाल राजा ध्रुपद को दर्शाया गया है। राजा ध्रुपद की तपस्या से धृष्टद्युम्न और द्रौपदी का जन्म हुआ। साथ ही शिखंडी का चित्रण है, जिनकी उपस्थिति ने युद्ध में भीष्म के पतन में निर्णायक भूमिका निभाई।`,
        
      },
      {
        title: "लाक्षागृह—अग्नि भवन",
        image: "images/main-attractions/block-b/block-b-3.png",
        description: `लाक्षागृह में दुर्योधन और शकुनि ने पांडवों व उनकी माता कुन्ती की हत्या की साज़ीश रची, जिसे कौरवों ने आसानी से जलाने योग्य बनाया था। पांडवों ने विदुर की सहायता से सुरंग बनाकर योजना विफल की। यह असफल प्रयास कुरुक्षेत्र युद्ध की आगाहनी है।`,
      },
      {
        title: "खांडवप्रस्थ की गाथा",
        image: "images/main-attractions/block-b/block-b-6.png",
        description: `खांडवप्रस्थ में भगवान अग्नि ब्राह्मण का रूप धारण कर अर्जुन और कृष्ण से खांडव वन जलाने में मदद मांगते हैं। नागों सहित वन जलता है, केवल अश्वसेन बचता है। दो मूर्तियाँ अर्जुन को वन को लक्ष्य करते हुए और परीक्षित को तक्षक के प्राणघातक काटने से पूर्व, ध्यान करते हुए दर्शाती हैं।`,
      },
      {
        title: "द्रोपदी का स्वयंवर",
        image: "images/main-attractions/block-b/block-b-4.png",
        description: `यह प्रसंग द्रौपदी के स्वयंवर का अनुभव प्रस्तुत करती है, जिसमें अर्जुन की अति-यथार्थवादी मूर्ति धनुष लिए मछली की आँख को भेदने के लिए तैयार है। राजा ध्रुपद की चुनौती पूरी कर अर्जुन ने कौशल दिखाया और स्वयंवर के अनुसार द्रौपदी से विवाह संपन्न हुआ।`,
      },
      {
        title: "द्रौपदी का स्वयंवर",
        image: "images/main-attractions/block-b/block-b-5.png",
        description: `यह प्रसंग द्रौपदी के स्वयंवर का अनुभव प्रस्तुत करती है, जिसमें अर्जुन की अति-यथार्थवादी मूर्ति धनुष लिए मछली की आँख को भेदने के लिए तैयार है। राजा ध्रुपद की चुनौती पूरी कर अर्जुन ने कौशल दिखाया और स्वयंवर के अनुसार द्रौपदी से विवाह संपन्न हुआ।`,
        label: "मुख्य आकर्षण",
      },
      
      {
        title: "चौसर – षड्यन्त्र के पासे",
        image: "images/main-attractions/block-b/block-b-7.png",
        description: `यह प्रसंग प्रसिद्ध चौसर खेल के दिन हस्तिनापुर के दरबार की पुनर्रचना प्रस्तुत करती है, जहाँ प्रत्येक चाल राज्य के भविष्य को प्रभावित करती है। छत से लटका विशाल पासा खेल की गंभीरता और अप्रत्याशितता की याद दिलाता है। यह क्षण सम्मान, महत्वाकांक्षा, धार्मिकता और छल के संघर्ष को दर्शाता है।`,
      },
      {
        title: "द्रौपदी-भीष्म धर्म संवाद",
        image: "images/main-attractions/block-b/block-b-8.png",
        description: `चौसर खेल के बाद द्रौपदी का संवाद महाभारत में गहन प्रतिरोध का प्रतीक है। उनके शब्द अन्यायपूर्ण सामाजिक व्यवस्था के खिलाफ अवज्ञा और उत्पीड़न के प्रतिरोध को व्यक्त करते हैं। खेल की वैधता पर सवाल उठाकर और बुजुर्गो के समक्ष अपने अधिकार की अवहेलना बताकर, वे न्याय और धैर्य का प्रतीक हैं।`,
        label: "मुख्य आकर्षण",
      },
      // Add other items here...
    ],
  };

  return (
    <div className="main_attractions_list">
      {content[language].map((item, index) => (
        <div className="list_item" id={`ma-blockb-${index}`} key={index}>
          <div className="attraction_image">
            <img src={item.image} alt={item.title} />
          </div>
          <div className="attranction_details">
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            {item.label && <span className="main-attraction-label">{item.label}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Blocka;
